import { render, staticRenderFns } from "./ChipsLastStatement.vue?vue&type=template&id=788ed2fa&"
import script from "./ChipsLastStatement.vue?vue&type=script&lang=js&"
export * from "./ChipsLastStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports